module.exports = "<md-button class=\"md-fab md-fab-bottom-right md-primary\" aria-label=\"{{::'Tasks Assigned to You' | translate}}\"\n\t\tng-click=\"vm.showTask($event)\" ng-if=\"vm.task\" ng-hide=\"vm.isTaskPanelShown\">\n\t<md-icon class=\"material-icons\">assignment_late</md-icon>\n</md-button>";


//////////////////
// WEBPACK FOOTER
// ./src/sharebase-app/components/task-panel/task-panel-button.template.html
// module id = 1268
// module chunks = 0